/*global FakeCation, StackBlur*/
(function (FC) {
  "use strict";

  FC.utils.registerBlender('scale', function (imgData, background, cb, config) {
    var tmpCanvas = document.createElement('canvas'),
        overlayCanvas, overlayBgCanvas,
        ctx, oCtx,
        image = document.createElement('canvas'),
        scale = config && config.scale || .7,
        hScale,
        useOverlay = config && config.useOverlay || false, // TODO refactor out from here
        left,
        right,
        bottom,
        top;

    image.width = imgData.width;
    image.height = imgData.height;
    tmpCanvas.width = background.width;
    tmpCanvas.height = background.height;

    hScale = background.height / image.height * scale;

    if (hScale > 1) {
      hScale = Math.min(background.width / image.width, hScale);
    }

    left = config.left || 0;
    right = left + image.width * hScale;

    bottom = tmpCanvas.height + (config.bottom || 0);
    top = bottom - image.height * hScale;

    image.getContext('2d').putImageData(imgData, 0, 0);

    ctx = tmpCanvas.getContext('2d');

    ctx.globalCompositeOperation = 'source-over'; // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/globalCompositeOperation

    if (useOverlay) {
      overlayCanvas = document.createElement('canvas');
      overlayCanvas.width = background.width;
      overlayCanvas.height = background.height;
      oCtx = overlayCanvas.getContext('2d');
      oCtx.drawImage(image, left, top, right - left, bottom - top);

      overlayBgCanvas = document.createElement('canvas');
      overlayBgCanvas.width = background.width;
      overlayBgCanvas.height = background.height;
      overlayBgCanvas.getContext('2d').drawImage(background, 0, 0);

      StackBlur.canvasRGBA(overlayBgCanvas, 0, 0, tmpCanvas.width, tmpCanvas.height, 30);

      oCtx.globalAlpha = 0.3;
      oCtx.globalCompositeOperation = "overlay";

      oCtx.drawImage(overlayCanvas, 0, 0);

      ctx.drawImage(background, 0, 0);
      ctx.drawImage(overlayCanvas, 0, 0);
    } else {
      ctx.drawImage(background, 0, 0);
      ctx.drawImage(image, left, top, right - left, bottom - top);
    }

    cb(ctx.getImageData(0, 0, tmpCanvas.width, tmpCanvas.height));
  });
}(FakeCation));
